import { render, staticRenderFns } from "./AddRemoveMasterBlock.vue?vue&type=template&id=0276dd0a"
import script from "./AddRemoveMasterBlock.vue?vue&type=script&lang=js"
export * from "./AddRemoveMasterBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports